var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20H1a1 1 0 01-1-1V1a1 1 0 011-1h16a1 1 0 011 1v18a1 1 0 01-1 1zM4 4v4h4V4H4zm0 6v2h10v-2H4zm0 4v2h10v-2H4zm6-9v2h4V5h-4z",
    fill: "#F8FAFF"
  })));
}
export default SvgAbout;